import { handleGetRequest, handlePostRequest } from "../hooks/api";
export async function GetProfile() {
  const endpoint = "/auth/me";

  const response = await handleGetRequest(endpoint, undefined);
  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}

export async function getAvatars(gender) {
  const endpoint = "/auth/get-avatars?gender="+gender;

  const response = await handleGetRequest(endpoint, undefined);
  return response;
}

export async function deleteAccountService(){
  const endpoint="/auth/delete-account"
  const response=await handleGetRequest(endpoint,undefined)
  return response

}

export async function updateHoroscopePreference(userId, horoscopeType, horoscopeSign) {
  const endpoint = "/user/updateHoroscopePreference";
  
  const payload = {
    userId: userId,
    horoscope_type: horoscopeType,
    horoscope_sign: horoscopeSign
  };

  const response = await handlePostRequest(endpoint, payload, undefined);
  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}
